import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import AuctionsPage from 'pages/auctions';
import WinnersPage from 'pages/winners';
import FinalWinner from 'pages/finalWinner';
import DetailPage from 'pages/detail';
import NotifyPage from 'pages/notify';
import ErrorPageOffer from 'pages/error/errorOffer';
import ErrorPageNotify from 'pages/error/errorNotify';
import ErrorPageStaff from 'pages/error/errorStaff';
import FinalWinnerSuccesPage from 'pages/finalWinnerSucces';
import ErrorPageConsecutive from 'pages/error/errorConsecutive';
import HomePage from '../pages/home';

const Router = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/subastas" element={<AuctionsPage />} />
        <Route path="/ganadores" element={<WinnersPage />} />
        <Route path="/notify" element={<NotifyPage />} />
        <Route path="/subastas-ganador" element={<FinalWinner />} />
        <Route path="/subastas-ganador-final" element={<FinalWinnerSuccesPage />} />
        <Route path="/subastas/:name/:id" element={<DetailPage />} />
        <Route path="/errorOffer" element={<ErrorPageOffer />} />
        <Route path="/errorConsecutive" element={<ErrorPageConsecutive />} />
        <Route path="/errorNotify" element={<ErrorPageNotify />} />
        <Route path="/errorStaff" element={<ErrorPageStaff />} />
      </Routes>
    </HashRouter>
  );
};

export default Router;
